module.exports = "<div class=\"quill-editor\"></div>"